import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset5_PD_6W_OCCO: string = '*';

export const order_ruleset5_PD_6W_OCCO  = 'abs(v - 1), label';

const getAttributes = (rawName: string) => ({
    dn: `$.15.${rawName}`,
    pn: `$.528.${rawName}`,
    flow1: `$.510.${rawName}`,
    flow2: `$.511.${rawName}`,
    dpmax: `$.28.${rawName}`,
});

export const buildQuery_ruleset5_PD_6W_OCCO: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    volumetricFlow2,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       ifnull(cast(attrs.value as float), 0)  as kvs1,
                       ifnull(cast(attrs2.value as float), 0) as kvs2,
                       cast(dnAttr.value as float) as DN,
                       cast(pnAttr.value as float) as PN,
                       cast(dpmaxAttr.value as float) as dpmax,
                       product.id,
                       label,
                       attributes
                    FROM product 
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.flow1)}) as attrs
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.flow2)}) as attrs2
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.dn)}) as dnAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.pn)}) as pnAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.dpmax)}) as dpmaxAttr
                    WHERE ${filter})
            , bounds as (SELECT cast(? as float) as v100_1, cast(? as float) as v100_2)
            , data as (SELECT 
                           3 as rank,
                           id,
                           label,
                           attributes,
                           CASE WHEN DN > 0 AND bounds.v100_1 > 0 AND bounds.v100_2 > 0 THEN 
                                min(
                                        bounds.v100_1 / (3600 * pi() * pow(DN / 1000 / 2, 2)),
                                        bounds.v100_2 / (3600 * pi() * pow(DN / 1000 / 2, 2))
                                )
                             ELSE 0 END as v,
                           PN,
                           DN
                       FROM products_filtered
                       JOIN bounds
                       WHERE CASE WHEN dpmax > 0 THEN
                                dpmax >= max(
                                    100 * pow(bounds.v100_1 / kvs1, 2),
                                    100 * pow(bounds.v100_2 / kvs2, 2)
                                )
                             ELSE true END  
                             AND CASE WHEN DN > 0 AND bounds.v100_1 > 0 AND bounds.v100_2 > 0 THEN 
                                bounds.v100_1 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= 4
                                AND bounds.v100_2 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= 4
                             ELSE true END
                       ORDER BY label)
         SELECT ${selectFields}
         FROM data
        `,
        [volumetricFlow, volumetricFlow2]
    ];
}



